<template>
  <div class="card p-3 shadow">
    <div v-if="error" class="alert alert-danger">{{error}}</div>

    <HealthStatus
        v-if="tab === 'status'"
        :client="client"
        :elements="elements"
        :status="status"
        v-on:show="showPresentation"
        v-on:update="updateHealthStatus" />

    <HealthPresentation
        v-if="element && slides.length > 0"
        :element="element"
        :slides="slides"
        v-on:close="healthId = null" />
  </div>
</template>

<script>
  import HealthStatus from './health/Status';
  import HealthPresentation from './health/Presentation';

  export default {
    name: 'Health',

    components: {HealthStatus, HealthPresentation},

    props: ['client'],

    data() {
      return {
        loading: true,
        error: '',
        tab: 'status',
        healthId: null,
      };
    },

    created() {
      this.loadData();
    },

    computed: {
      elements() {
        return this.$store.state.clinic.healthElements;
      },

      element() {
        return this.elements.find(e => e.id === this.healthId);
      },

      content() {
        return this.$store.state.clinic.healthContent;
      },

      slides() {
        const slides = [];
        const elements = [this.element];

        for (const element of this.elements) {
          if (element.parent === this.element.id) {
            elements.push(element);
          }
        }

        for (const content of this.content) {
          const element = elements.find(e => e.id === content.health);

          if (typeof element === 'undefined') {
            continue;
          }

          const mult = element.id === this.element.id ? 10 : 100;

          slides.push({
            id: content.id,
            image: content.image,
            text: content.text,
            sort: element.sort * mult + content.sort,
          });
        }

        return slides;
      },

      status() {
        const values = {};
        const state = this.$store.getters.clientHealthState(this.client.id);

        state.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

        for (const item of state) {
          values[item.health] = item.value;
        }

        return values;
      },
    },

    methods: {
      async loadData() {
        try {
          this.loading = true;

          await Promise.all([
            this.$store.dispatch('LOAD_HEALTH_ELEMENTS'),
            this.$store.dispatch('LOAD_HEALTH_STATE', this.client.id),
            this.$store.dispatch('LOAD_HEALTH_CONTENT'),
          ]);
        } catch (e) {
          this.error = `При загрузке данных: ${e.message}`;
        }

        this.loading = false;
      },

      showPresentation(id) {
        this.healthId = id;
      },

      async updateHealthStatus(data) {
        try {
          this.loading = true;

          const {health, value} = data;

          await this.$store.dispatch('ADD_HEALTH_STATE', {
            data: { user: this.client.id, values: [{health, value}] },
          });
        } catch (e) {
          this.error = `При обновлении статуса произошла ошибка: ${e.message}`;
        }

        this.loading = false;
      },
    },
  };
</script>
